<swap-modal [modalId]="modalId" [centered]="true">
  <div class="row m-3">
    <div class="col-12 d-flex mb-3">
      <h5 class="modal-title mb-0 fw-bolder" id="exampleModalLabel">
        Choose time
      </h5>
      <button
        type="button"
        class="closeBtn d-none"
        data-bs-dismiss="modal"
        aria-label="Close"
        #closeBtn
      >
        <img loading="lazy" src="assets/icons/close-icon.svg" alt="" />
      </button>
    </div>
    <div class="col-12 mb-2">
      <p class="mb-2">Choose from the time below to extend negotiation</p>
      <div class="d-flex align-items-center gap-2 justify-content-center">
        <button
          class="timerBtn"
          *ngFor="let time of timers"
          [ngClass]="{ active: selectedTimer == time }"
          (click)="selectedTimer = time"
        >
          <img loading="lazy" [src]="time.img" alt="" />
          <p class="mb-0">
            {{ time.value }}
            mins
          </p>
        </button>
      </div>
      <div class="d-flex align-items-center gap-2 mt-4">
        <button
          (click)="selectedTimer = null; closeBtn.click()"
          class="submit-btn fw-700 font-13 btn-decline"
        >
          Cancel
        </button>
        <button
          class="submit-btn fw-700 font-13"
          (click)="chooseTimer()"
          [disabled]="!selectedTimer"
        >
          Confirm
        </button>
      </div>
    </div>
  </div>
</swap-modal>
